import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Tab, TabList, TabPanel } from "@similarweb/ui-components";

export const TabsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px 0 0;
    background-color: ${colorsPalettes.carbon[0]};
    ${setElevation("Z1")}
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    border-radius: 5px 5px 0px 0px;
`;

export const ContentContainer = styled.div`
    flex-grow: 1;
    display: flex;
    padding: 0px;
    justify-content: center;
    background-color: ${colorsPalettes.carbon["0"]};
    ${TabPanel} {
        margin: 0 auto;
    }
    .react-tabs {
        width: 100%;
    }
`;

export const TabListStyled = styled(TabList)`
    border-bottom: 0;
    z-index: 1;
    .firstTab,
    .secondTab {
        padding: 18px 24px;
    }
`;

export const StyledTab = styled(Tab)`
    gap: 4px;
`;
